import "../phaser.min.js";
import Common from "../Includes/Common.js";
import GameOver from "./GameOver";
class GameScene extends Phaser.Scene {
    constructor() {
        super('GameScene');
        this.common = new Common();
    }

    preload() {
        const width = this.cameras.main.width;
        const height = this.cameras.main.height;

        this.add.rectangle(0, 0, width, height, 0x487ab6).setOrigin(0, 0);

        // 2. Create the visual background box for the progress bar
        const progressBarBox = this.add.graphics();
        progressBarBox.fillStyle(0x3d6899, 0.8);
        progressBarBox.fillRect(width / 2 - 160, height / 2 - 25, 320, 50);

        // 3. Create the actual filling progress bar
        const progressBar = this.add.graphics();

        // 4. Create text styling objects
        const loadingText = this.make.text({
            x: width / 2 - 150,
            y: height / 2 - 50,
            text: 'Loading...',
            style: { font: '20px monospace', fill: '#ffffff' }
        }).setOrigin(0, 0.5);

        const percentText = this.make.text({
            x: width / 2,
            y: height / 2 + 50,
            text: '0%',
            style: { font: '18px monospace', fill: '#ffffff' }
        }).setOrigin(0.5, 0.5);

        // 5. Hook up the loader progress event
        this.load.on('progress', (value) => {
            percentText.setText(parseInt(value * 100) + '%');
            progressBar.clear();
            progressBar.fillStyle(0xffffff, 1);
            progressBar.fillRect(width / 2 - 150, height / 2 - 15, 300 * value, 30);
        });

        // 6. Optional: Listen for individual file loads to show what asset is loading
        this.load.on('fileprogress', (file) => {
            loadingText.setText('Loading asset: ' + file.key);
        });

        // 7. Fire when everything in the queue has successfully completed
        this.load.on('complete', () => {
            // Destroy visual UI assets to free up memory before changing scenes
            progressBar.destroy();
            progressBarBox.destroy();
            loadingText.destroy();
            percentText.destroy();

            // Transition to your actual game scene
            this.scene.launch('BackgroundManager', {scrollSpeed: 100})
            this.scene.get('BackgroundManager').transitionTo('ReflectionBackground', 50);
            this.scene.launch('Start')
            this.scene.launch('Ui')
        });

        const audioPath = this.common.audioPath;
        const assetsPath = this.common.assetsPath;

        this.load.font('pixelify', assetsPath + 'fonts/Jersey_10/Jersey10-Regular.ttf');

        this.load.audio('sas', audioPath + 'sas-grunt.mp3')
        this.load.audio('moo', audioPath + 'moo.wav')
        this.load.audio('tractor', audioPath + 'tractor.wav')
        this.load.audio('coin', audioPath + 'coin.wav')
        this.load.audio('flap1', audioPath + 'Bird Wing Flap 01.wav')
        this.load.audio('flap2', audioPath + 'Bird Wing Flap 02.wav')
        this.load.audio('flap3', audioPath + 'Bird Wing Flap 03.wav')
        this.load.audio('flap4', audioPath + 'Bird Wing Flap 04.wav')
        this.load.audio('blip', audioPath + 'retro-blip.mp3')
        this.load.audio('success', audioPath + 'Fruit collect 1.wav')
        this.load.audio('fail', audioPath + 'Boss hit 1.wav')
        this.load.audio('win', audioPath + 'Game Win.wav')
        this.load.audio('highscore', audioPath + 'highscore.wav')
        this.load.audio('siren', audioPath + 'siren.wav')
        this.load.audio('lose', audioPath + 'loss.ogg')
        this.load.audio('intro-music', audioPath + 'intro.ogg');
        this.load.audio('accept', audioPath + 'accept.wav');
        this.load.audio('next', audioPath + 'next.wav');
        this.load.audio('button-click-error', audioPath + 'button-click-error.wav');
        this.load.audio('bg-music', audioPath + 'chiptune-major-remix.ogg');

        this.load.atlas('ui', assetsPath + 'sprites/ui-master.png', assetsPath + 'sprites/ui-master_atlas.json');
        this.load.atlas('level', assetsPath + 'sprites/levels-o.png', assetsPath + 'sprites/levels_atlas.json');
        this.load.atlas('cop-car', assetsPath + 'sprites/cars/cop-car.png', assetsPath + 'sprites/cars/cop-car.json');
    }

    create() {

    }
}

export default GameScene;